{
  "accountantActivity": {
    "title": "Activité comptable",
    "subtitle": "Audit SoD quotidien — volume d'actions monétaires par comptable/admin vs sa moyenne sur 30 jours (signalement : >10x la moyenne et >=5 actions)",
    "redFlagOnly": "Drapeaux rouges uniquement",
    "loading": "Chargement…",
    "empty": "Aucun rapport — le cron d'audit de 02h00 UTC en écrit un par jour",
    "emptyDetail": "Aucune activité enregistrée pour ce jour",
    "detailTitle": "Détail du rapport — {{date}}",
    "flaggedGeneric": "signalé",
    "columns": {
      "date": "Date",
      "generatedAt": "Généré",
      "totalEvents": "Événements totaux",
      "redFlags": "Drapeaux rouges",
      "digestRecipients": "Digest envoyé à",
      "user": "Utilisateur",
      "role": "Rôle",
      "creditMemos": "Notes de crédit",
      "markPaid": "Marqué payé",
      "refundTasks": "Tâches de remboursement",
      "total": "Total",
      "baseline": "Moyenne 30 j",
      "flagged": "Signalé"
    }
  },
  "auth": {
    "login": {
      "title": "Bon retour",
      "subtitle": "Connectez-vous à votre compte",
      "lockout": {
        "before": "Compte verrouillé. Déverrouillage dans"
      },
      "emailLabel": "E-mail",
      "emailPlaceholder": "nom@entreprise.com",
      "passwordLabel": "Mot de passe",
      "passwordPlaceholder": "Saisissez votre mot de passe",
      "showPassword": "Afficher le mot de passe",
      "hidePassword": "Masquer le mot de passe",
      "forgotPassword": "Mot de passe oublié ?",
      "submit": "Se connecter",
      "submitting": "Connexion…",
      "or": "OU",
      "continueLark": "Continuer avec Lark Suite",
      "noRegisterNotice": "Les comptes admin sont créés uniquement par le Superadmin.",
      "validation": {
        "emailInvalid": "E-mail invalide",
        "passwordMin": "Le mot de passe doit comporter au moins 8 caractères",
        "passwordMax": "Le mot de passe doit comporter au plus 128 caractères"
      },
      "stepUp": {
        "prompt": "Pour des raisons de sécurité, veuillez saisir le code OTP envoyé à votre e-mail.",
        "otpLabel": "Code OTP (6 chiffres)",
        "otpInvalid": "Le code OTP doit comporter 6 chiffres.",
        "otpWrong": "Le code OTP est incorrect ou a expiré.",
        "verify": "Vérifier le code OTP",
        "cancel": "Annuler"
      },
      "errors": {
        "invalidCredentials": "E-mail ou mot de passe incorrect.",
        "recaptchaFailed": "Échec de la vérification reCAPTCHA — veuillez réessayer.",
        "emailUnverified": "E-mail non vérifié. Contactez le Superadmin.",
        "twoFaRequired": "Authentification à deux facteurs requise — saisissez le code de votre application d'authentification.",
        "accountLocked": "Compte temporairement verrouillé après trop de tentatives échouées. Veuillez patienter quelques minutes et réessayer.",
        "accountLockedCountdown": "Compte temporairement verrouillé après trop de tentatives échouées. Déverrouillage dans {{time}}.",
        "pendingApproval": "Votre compte vendeur est en attente d'approbation par l'administrateur.",
        "rateLimit": "Trop de tentatives — veuillez patienter 15 minutes.",
        "validationFailed": "Les informations saisies sont invalides.",
        "authRequired": "Veuillez vous connecter pour continuer.",
        "forbidden": "Ce compte n'a pas accès.",
        "default": "Échec de la connexion. Veuillez réessayer."
      }
    },
    "forgot": {
      "title": "Mot de passe oublié",
      "subtitle": "Saisissez l'e-mail de votre compte — nous vous enverrons un lien de réinitialisation.",
      "emailLabel": "E-mail",
      "emailPlaceholder": "vous@entreprise.com",
      "submit": "Envoyer le lien",
      "submitting": "Envoi...",
      "backToLogin": "Retour à la connexion",
      "validation": {
        "emailInvalid": "E-mail invalide"
      },
      "success": {
        "title": "Vérifiez votre boîte de réception",
        "descBefore": "Si",
        "descAfter": "est enregistré, vous recevrez un lien de réinitialisation dans quelques minutes. Le lien est valable 15 minutes."
      }
    },
    "reset": {
      "title": "Définir un nouveau mot de passe",
      "subtitle": "Votre mot de passe doit respecter toutes les exigences ci-dessous.",
      "newPasswordLabel": "Nouveau mot de passe",
      "confirmPasswordLabel": "Confirmer le mot de passe",
      "rulesAria": "Exigences du mot de passe",
      "submit": "Définir le nouveau mot de passe",
      "submitting": "Traitement...",
      "backToLogin": "Retour à la connexion",
      "rules": {
        "len": "Au moins 12 caractères",
        "upper": "Au moins 1 lettre majuscule",
        "num": "Au moins 1 chiffre",
        "special": "Au moins 1 caractère spécial"
      },
      "validation": {
        "lenMin": "Le mot de passe doit comporter au moins 12 caractères",
        "upper": "Au moins 1 lettre majuscule requise",
        "num": "Au moins 1 chiffre requis",
        "special": "Au moins 1 caractère spécial requis",
        "confirmRequired": "Veuillez confirmer votre mot de passe",
        "mismatch": "Les mots de passe ne correspondent pas"
      },
      "flash": {
        "title": "Réinitialisation du mot de passe réussie",
        "desc": "Veuillez vous connecter avec votre nouveau mot de passe."
      },
      "errors": {
        "reused": "Ce mot de passe a été utilisé récemment. Veuillez en choisir un autre.",
        "requestFailed": "Échec de la requête (HTTP {{status}})",
        "unknown": "Erreur inconnue"
      },
      "invalid": {
        "title": "Lien invalide",
        "desc": "Le lien de réinitialisation a été utilisé ou a expiré (15 minutes). Veuillez demander un nouveau lien.",
        "requestNew": "Demander un nouveau lien"
      },
      "validating": "Vérification de votre lien de réinitialisation…"
    },
    "verify2fa": {
      "title": "Vérification en deux étapes (Admin)",
      "headlineEmail": "Saisissez le code OTP envoyé à votre e-mail",
      "headlineTotp": "Saisissez le code de votre application d'authentification (TOTP — Time-based One-Time Password)",
      "codeLabel": "Code à 6 chiffres",
      "codeAria": "Code à 6 chiffres",
      "trustDevice": "Faire confiance à cet appareil pendant 30 jours",
      "submit": "Confirmer",
      "submitting": "Vérification…",
      "backToLogin": "Retour à la connexion",
      "recoveryHint": "Vous avez perdu votre appareil d'authentification ? Contactez le Superadmin pour récupérer l'accès.",
      "errors": {
        "incomplete": "Veuillez saisir les 6 chiffres.",
        "sessionExpired": "Votre session de vérification a expiré — veuillez vous reconnecter.",
        "expired": "Le code a expiré — veuillez vous reconnecter.",
        "tooMany": "Trop de tentatives — veuillez patienter 15 minutes.",
        "invalid": "Le code de vérification est incorrect."
      }
    }
  },
  "setup": {
    "wizard": {
      "title": "Printway — Configuration initiale",
      "subtitle": "Effectuez 3 étapes pour initialiser le compte Super Admin",
      "progressAria": "Progression de l'assistant de configuration",
      "steps": {
        "step1": "Créer le Super Admin",
        "step2": "Activer la 2FA (double authentification)",
        "step3": "Codes de récupération"
      }
    },
    "createAdmin": {
      "heading": "Étape 1 — Créer le compte Super Admin",
      "descriptionBefore": "Ce compte sera le propriétaire du système. L'e-mail doit utiliser le domaine interne",
      "descriptionAfter": ".",
      "emailLabel": "E-mail du Super Admin",
      "nameLabel": "Nom d'affichage",
      "namePlaceholder": "Founding Admin",
      "passwordLabel": "Mot de passe",
      "passwordHint": "Au moins 12 caractères (selon la politique).",
      "confirmPasswordLabel": "Confirmer le mot de passe",
      "acceptTerms": "J'accepte les conditions d'utilisation de Printway et j'assume la responsabilité de la gestion de ce compte Super Admin.",
      "submit": "Continuer → Étape 2",
      "submitting": "Création…",
      "validation": {
        "emailRequired": "L'e-mail est requis",
        "emailInvalid": "E-mail invalide",
        "emailDomain": "L'e-mail doit se terminer par @printway.work",
        "nameRequired": "Le nom d'affichage est requis",
        "passwordMin": "Le mot de passe doit comporter au moins 12 caractères",
        "passwordMax": "Le mot de passe ne doit pas dépasser 128 caractères",
        "acceptTermsRequired": "Vous devez accepter les conditions d'utilisation",
        "passwordMismatch": "Les mots de passe ne correspondent pas"
      },
      "errors": {
        "missingToken": "Jeton de configuration manquant. Rouvrez le lien fourni lors du déploiement.",
        "createFailed": "Impossible de créer le Super Admin — veuillez réessayer"
      }
    },
    "enable2fa": {
      "heading": "Étape 2 — Activer la double authentification (2FA)",
      "descriptionBefore": "Scannez le code QR avec une application d'authentification (Google Authenticator, 1Password, Authy…) puis saisissez le code à 6 chiffres pour confirmer. Cette étape est ",
      "descriptionRequired": "obligatoire",
      "descriptionAfter": ".",
      "qrAlt": "Code QR TOTP (code QR pour configurer votre application d'authentification)",
      "qrGenerating": "Génération du code QR…",
      "qrError": "Impossible de générer le code QR — utilisez la clé manuelle ci-dessous.",
      "manualKeyLabel": "Clé manuelle (à saisir manuellement si vous ne pouvez pas scanner le QR) :",
      "manualKeyMissing": "(Aucune clé manuelle disponible — scannez le QR ci-dessus)",
      "accountLabel": "Compte : {{email}}",
      "emailUnknown": "(inconnu)",
      "issuerLabel": "Émetteur :",
      "totpCodeLabel": "Code de vérification à 6 chiffres",
      "submit": "Vérifier → Étape 3",
      "submitting": "Vérification…",
      "validation": {
        "totpFormat": "Le code TOTP doit comporter exactement 6 chiffres"
      },
      "errors": {
        "missingSetupToken": "Jeton de configuration manquant — revenez à l'étape 1 et réessayez.",
        "missingEnrollToken": "Jeton d'enrôlement manquant (TOTP) — revenez à l'étape 1 et réessayez.",
        "verifyFailed": "Code TOTP incorrect — veuillez réessayer"
      }
    },
    "recoveryCodes": {
      "heading": "Étape 3 — Codes de récupération",
      "descriptionBefore": "Voici 8 codes de récupération à usage unique (utilisés si vous perdez votre appareil 2FA). ",
      "descriptionStrong": "Affichés une seule fois",
      "descriptionAfter": ". Téléchargez-les et conservez-les hors ligne dans un endroit sûr (coffre, gestionnaire de mots de passe).",
      "generating": "Génération des codes de récupération…",
      "download": "Télécharger recovery-codes.txt",
      "ackStrong": "Enregistrés dans un endroit sûr.",
      "ackRest": " Je comprends que ces codes de récupération ne seront plus affichés — en cas de perte, je devrai réinitialiser la 2FA via le processus d'assistance.",
      "complete": "Terminer → Connexion",
      "completing": "Redirection…",
      "errors": {
        "missingToken": "Jeton de configuration manquant — revenez à l'étape 1 et recommencez.",
        "loadFailed": "Impossible de charger les codes de récupération — veuillez réessayer"
      },
      "bannerTitle": "Printway — Codes de récupération (Super Admin)",
      "bannerNote": "Conservez ce fichier dans un endroit sûr (hors ligne). Chaque code ne peut être utilisé qu'une seule fois."
    },
    "errors": {
      "httpFailed": "Échec de la requête (HTTP {{status}})"
    }
  },
  "profile": {
    "account": {
      "title": "Mon compte",
      "subtitle": "Gérez vos informations personnelles, votre sécurité et vos sessions de connexion.",
      "tabsAria": "Sections du compte",
      "formAria": "Formulaire de profil",
      "loading": "Chargement des informations du compte…",
      "loadError": "Échec du chargement du compte",
      "tabs": {
        "profile": "Profil",
        "security": "Sécurité",
        "notifications": "Notifications",
        "preferences": "Préférences",
        "activity": "Activité"
      },
      "fields": {
        "email": "E-mail",
        "role": "Rôle",
        "firstName": "Prénom",
        "lastName": "Nom",
        "phone": "Numéro de téléphone",
        "country": "Pays",
        "avatarUrl": "Avatar (URL)"
      },
      "emailReadonly": "L'e-mail ne peut pas être modifié.",
      "saveErrorFallback": "Échec de l'enregistrement des modifications",
      "saveSuccess": "Modifications enregistrées.",
      "save": "Enregistrer les modifications",
      "saving": "Enregistrement…",
      "security": {
        "passwordTitle": "Changer le mot de passe",
        "passwordDesc": "Changez votre mot de passe en saisissant votre mot de passe actuel et un nouveau.",
        "changePassword": "Changer le mot de passe",
        "twoFactorTitle": "Authentification à deux facteurs (2FA)",
        "twoFactorStatus": "Statut :",
        "twoFactorOn": "Activée",
        "twoFactorOff": "Non activée",
        "twoFactorDesc": "Activez l’authentification à deux facteurs pour mieux sécuriser votre compte (TOTP ou code OTP par e-mail).",
        "sessionsTitle": "Sessions de connexion",
        "manageSessions": "Gérer les sessions de connexion",
        "enableTwoFactor": "Activer la 2FA",
        "manageTwoFactor": "Gérer la 2FA"
      },
      "notifications": {
        "category": "Catégorie",
        "quietHours": "Heures silencieuses",
        "quietHoursDesc": "Suspendre les notifications push pendant ces heures.",
        "channels": {
          "email": "E-mail",
          "push": "Push",
          "in_app": "Dans l'app"
        },
        "categories": {
          "orders": "Commandes",
          "shipping": "Expédition",
          "payment": "Paiement",
          "wallet": "Portefeuille",
          "billing": "Facturation",
          "system": "Système",
          "marketing": "Marketing"
        },
        "testEmail": "E-mail de test",
        "testEmailDesc": "Envoyer un e-mail de notification exemple à l'adresse de votre compte.",
        "testEmailSend": "Envoyer l'e-mail de test",
        "testEmailSending": "Envoi…",
        "testEmailSent": "E-mail de test envoyé. Vérifiez votre boîte de réception.",
        "testEmailNotSent": "L'e-mail de test n'a pas pu être envoyé. Veuillez réessayer.",
        "testEmailError": "Impossible d'envoyer l'e-mail de test. Veuillez réessayer."
      },
      "preferences": {
        "groups": {
          "regional": "Régional",
          "display": "Affichage",
          "email": "E-mail"
        },
        "fields": {
          "language": "Langue",
          "currency": "Devise",
          "dateFormat": "Format de date",
          "timezone": "Fuseau horaire",
          "theme": "Thème",
          "density": "Densité",
          "dashboardView": "Vue du tableau de bord",
          "emailDigest": "Résumé e-mail"
        },
        "options": {
          "theme": {
            "system": "Système",
            "light": "Clair",
            "dark": "Sombre",
            "auto": "Auto"
          },
          "density": {
            "normal": "Normal",
            "compact": "Compact"
          },
          "dashboardView": {
            "expanded": "Étendu",
            "compact": "Compact"
          },
          "emailDigest": {
            "none": "Aucun",
            "daily": "Quotidien",
            "weekly": "Hebdomadaire",
            "monthly": "Mensuel"
          }
        },
        "descriptions": {
          "regional": "Langue, devise et format de date/heure.",
          "display": "Thème d'apparence."
        },
        "themeHints": {
          "light": "Thème clair",
          "dark": "Thème sombre",
          "system": "Suivre l’appareil",
          "auto": "Clair 6h–18h, sombre ensuite"
        }
      },
      "activity": {
        "empty": "Aucune activité de compte récente."
      }
    },
    "sessions": {
      "title": "Sessions de connexion actives",
      "subtitle": "Liste des appareils / navigateurs accédant actuellement à votre compte.",
      "tableAria": "Sessions actives",
      "revokeAll": "Tout révoquer",
      "revokingAll": "Révocation…",
      "revokeOneSuccess": "Session de connexion révoquée.",
      "revokeOneError": "Échec de la révocation de la session",
      "revokeAllSuccess_one": "{{count}} session révoquée.",
      "revokeAllSuccess_other": "{{count}} sessions révoquées.",
      "revokeAllError": "Échec de la révocation de toutes les sessions",
      "loading": "Chargement des sessions…",
      "loadError": "Échec du chargement de la liste des sessions",
      "empty": "Aucune session de connexion trouvée.",
      "columns": {
        "device": "Appareil",
        "ip": "IP",
        "start": "Début",
        "lastSeen": "Dernière activité",
        "actions": "Actions"
      },
      "currentBadge": "Session actuelle",
      "emptyUserAgent": "User-Agent vide",
      "revoke": "Révoquer",
      "revoking": "Révocation…",
      "deviceLabels": {
        "unknown": "Inconnu",
        "browser": "Navigateur"
      },
      "browserLabels": {
        "other": "Autre"
      },
      "activeTitle": "Sessions actives",
      "activeSubtitle": "Appareils actuellement connectés à votre compte. Révoquez toute session que vous ne reconnaissez pas.",
      "deviceOn": "sur",
      "signOut": "Se déconnecter"
    },
    "preferences": {
      "title": "Préférences",
      "subtitle": "Personnalisez l'apparence, la langue, le fuseau horaire et les notifications.",
      "formAria": "Formulaire de préférences",
      "loading": "Chargement des préférences…",
      "loadError": "Échec du chargement des préférences",
      "theme": {
        "legend": "Apparence",
        "light": "Clair",
        "dark": "Sombre",
        "system": "Système"
      },
      "language": {
        "label": "Langue"
      },
      "timezone": {
        "label": "Fuseau horaire"
      },
      "dateFormat": {
        "label": "Format de date"
      },
      "notifications": {
        "legend": "Notifications",
        "emailLabel": "Recevoir des e-mails",
        "emailDesc": "Notifications facultatives ; les e-mails transactionnels (réinitialisation du mot de passe, 2FA) sont toujours envoyés.",
        "smsLabel": "Recevoir des SMS"
      },
      "saveErrorFallback": "Échec de l'enregistrement des préférences",
      "saveSuccess": "Préférences enregistrées.",
      "save": "Enregistrer les préférences",
      "saving": "Enregistrement…"
    },
    "loginHistory": {
      "title": "Historique de connexion",
      "tableAria": "Historique de connexion",
      "subtitle": "Tentatives de connexion réussies et échouées récentes sur votre compte.",
      "columns": {
        "status": "Statut",
        "ts": "Horodatage",
        "ip": "IP",
        "device": "Appareil",
        "browser": "Navigateur",
        "reason": "Raison"
      },
      "filter": {
        "from": "Du",
        "to": "Au"
      },
      "loading": "Chargement…",
      "loadError": "Impossible de charger l'historique de connexion.",
      "empty": "Aucune tentative de connexion dans cette période.",
      "pager": {
        "aria": "Pagination",
        "pageSize": "Lignes par page",
        "total": "{{total}} enregistrements",
        "prev": "Précédent",
        "next": "Suivant"
      }
    },
    "activity": {
      "viewLoginHistory": "Voir l'historique de connexion"
    }
  },
  "auditLog": {
    "page": {
      "title": "Journal d'audit",
      "subtitle": "Piste d'audit à l'échelle du système. En lecture seule, immuable."
    },
    "actions": {
      "exportCsv": "Exporter en CSV",
      "view": "Voir",
      "loadMore": "Charger plus",
      "loading": "Chargement…"
    },
    "columns": {
      "timestamp": "Horodatage",
      "actor": "Acteur",
      "action": "Action",
      "entity": "Entité",
      "details": "Détails"
    },
    "loading": "Chargement du journal d'audit…",
    "empty": {
      "title": "Aucune entrée de journal",
      "body": "Essayez d'ajuster les filtres ou d'élargir la plage de dates."
    },
    "footer": {
      "showing_one": "Affichage de {{count}} entrée",
      "showing_other": "Affichage de {{count}} entrées",
      "loadingMore": " • chargement…"
    },
    "drawer": {
      "title": "Entrée d'audit — {{action}}",
      "close": "Fermer"
    },
    "fields": {
      "timestamp": "Horodatage",
      "actor": "Acteur",
      "action": "Action",
      "entity": "Entité",
      "requestId": "Request ID",
      "merchantId": "Merchant ID",
      "ip": "IP",
      "userAgent": "User Agent"
    },
    "json": {
      "oldValue": "Ancienne valeur",
      "newValue": "Nouvelle valeur",
      "metadata": "Metadata"
    },
    "relative": {
      "seconds": "il y a {{count}}s",
      "minutes": "il y a {{count}}m",
      "hours": "il y a {{count}}h",
      "days": "il y a {{count}}j",
      "months": "il y a {{count}}mo",
      "years": "il y a {{count}}a"
    },
    "filters": {
      "actorLabel": "E-mail de l'acteur",
      "actorPlaceholder": "rechercher par e-mail…",
      "searchLabel": "Recherche",
      "searchPlaceholder": "rechercher action, id cible, e-mail…",
      "searchAria": "Recherche libre",
      "clear": "Effacer les filtres",
      "dateRange": "Plage de dates",
      "from": "Du",
      "to": "Au",
      "action": "Action",
      "entityType": "Type d'entité"
    },
    "presets": {
      "7d": "7 derniers jours",
      "30d": "30 derniers jours",
      "90d": "90 derniers jours",
      "custom": "Plage personnalisée"
    },
    "toast": {
      "loadFailTitle": "Échec du chargement du journal d'audit",
      "unknown": "Inconnu"
    }
  },
  "audit": {
    "loading": "Chargement du journal d'audit…",
    "empty": {
      "title": "Aucune entrée de journal",
      "body": "Essayez d'ajuster les filtres ou d'élargir la plage de dates."
    },
    "errors": {
      "loadFailed": "Impossible de charger le journal d'audit"
    },
    "columns": {
      "timestamp": "Horodatage",
      "actor": "Acteur",
      "role": "Rôle",
      "entity": "Entité",
      "entityId": "ID d'entité",
      "action": "Action",
      "ip": "IP",
      "userAgent": "User Agent",
      "diff": "Diff",
      "severity": "Gravité"
    },
    "filters": {
      "action": "Action",
      "allActions": "— Toutes les actions —",
      "entityType": "Type d'entité",
      "allEntities": "— Les 24 entités —",
      "actorUserId": "ID utilisateur de l'acteur",
      "actorUserIdPlaceholder": "ObjectId (24 hex)",
      "actorRole": "Rôle de l'acteur",
      "all": "— Tous —",
      "severity": "Gravité",
      "dateFrom": "À partir du",
      "dateTo": "Jusqu'au",
      "search": "Recherche (q)",
      "searchPlaceholder": "Action/entité/IP/UA…",
      "clear": "Effacer tous les filtres"
    },
    "footer": {
      "showing_one": "Affichage de {{count}} entrée",
      "showing_other": "Affichage de {{count}} entrées",
      "loadingMore": " • chargement…"
    },
    "actions": {
      "loadMore": "Charger plus",
      "loading": "Chargement…"
    },
    "relativeAgo": "il y a {{value}}",
    "diff": {
      "changesAria_one": "{{count}} modification",
      "changesAria_other": "{{count}} modifications",
      "viewTooltip": "Cliquer pour voir le diff",
      "noChanges": "Cet événement n'a modifié aucune donnée (aucun diff à afficher).",
      "columnField": "Champ (key-path)",
      "columnBefore": "Avant",
      "columnAfter": "Après",
      "collapse": "Réduire",
      "expandAll": "Voir tout ({{count}} éléments)",
      "truncated": "Diff tronqué — seuls les 50 premiers champs sont affichés. Ouvrez « Voir le JSON complet » pour voir l'intégralité du payload.",
      "showJson": "Voir le JSON complet",
      "hideJson": "Masquer le JSON complet",
      "rawBefore": "Avant (brut)",
      "rawAfter": "Après (brut)",
      "kind": {
        "added": "+ Ajouté",
        "removed": "- Supprimé",
        "modified": "~ Modifié",
        "unchanged": "= Inchangé"
      }
    },
    "multiSelect": {
      "all": "— Tous —",
      "selectedCount": "{{count}} sélectionné(s)",
      "filterPlaceholder": "Filtrer les options…",
      "noMatch": "Aucune option correspondante",
      "clearAll": "Tout désélectionner",
      "close": "Fermer"
    },
    "archive": {
      "bannerTitle": "Recherche dans le stockage froid (S3) — les résultats peuvent prendre jusqu'à 30 secondes.",
      "bannerBody": "Seuls les enregistrements de plus de 180 jours sont affichés. Les données personnelles (PII) sont pseudonymisées avant d'être renvoyées.",
      "dateFrom": "À partir du *",
      "dateTo": "Jusqu'au *",
      "actorPlaceholder": "ObjectId / pseudonymisé",
      "searchPlaceholder": "Requête libre — action/entité/ip…",
      "scanning": "Analyse de S3",
      "estimate": " (~{{seconds}}s)",
      "runButton": "Rechercher dans le stockage froid",
      "unavailable": "Le stockage froid est temporairement indisponible",
      "idlePrefix": "Sélectionnez une plage de dates (plus de 180 jours) et cliquez sur ",
      "idleSuffix": " pour commencer.",
      "pseudonymized": "PII pseudonymisées",
      "scanned_one": "{{count}} objet S3 analysé",
      "scanned_other": "{{count}} objets S3 analysés",
      "searching": "Recherche dans le stockage froid…",
      "empty": "Aucun enregistrement trouvé dans le stockage froid pour cette plage de dates."
    },
    "actionLabels": {
      "AUTH_USER_UPDATE": "Utilisateur — Mise à jour",
      "AUTH_PROFILE_UPDATE": "Profil — Mise à jour",
      "AUTH_USER_SUSPEND": "Utilisateur — Suspension",
      "AUTH_USER_UNSUSPEND": "Utilisateur — Réactivation",
      "AUTH_USER_ROLE_GRANT": "Utilisateur — Attribution de rôle",
      "AUTH_USER_ROLE_REVOKE": "Utilisateur — Révocation de rôle",
      "AUTH_2FA_SETUP": "2FA — Configuration",
      "AUTH_2FA_DISABLED": "2FA — Désactivé",
      "AUTH_2FA_VERIFY": "2FA — Vérification",
      "AUTH_USER_2FA_RESET": "2FA — Réinitialisé par admin",
      "AUTH_BILLING_UPDATE": "Facturation — Mise à jour",
      "AUTH_LOGIN_FAILED": "Authentification — Échec de connexion",
      "AUTH_LOGIN_LOCKED": "Authentification — Connexion verrouillée",
      "ADMIN_ROLE_CREATE": "Rôle — Création",
      "ADMIN_ROLE_UPDATE": "Rôle — Mise à jour",
      "ADMIN_ROLE_DELETE": "Rôle — Suppression",
      "AUTH_LOGIN": "Authentification — Connexion",
      "AUTH_LOGOUT": "Authentification — Déconnexion",
      "AUTH_REGISTER": "Authentification — Inscription",
      "AUTH_OTP_VERIFY": "Authentification — Vérification OTP",
      "AUTH_OTP_RESEND": "Authentification — Renvoi OTP",
      "AUTH_PASSWORD_CHANGE": "Authentification — Changement de mot de passe",
      "AUTH_PASSWORD_RESET": "Authentification — Réinitialisation du mot de passe",
      "AUTH_PASSWORD_RESET_REQUESTED": "Authentification — Réinitialisation du mot de passe demandée",
      "AUTH_REFRESH": "Authentification — Rafraîchissement du token",
      "AUTH_TOKEN_REUSE": "Authentification — Réutilisation de token détectée",
      "AUTH_OAUTH_LOGIN_INITIATED": "Authentification — Connexion OAuth initiée",
      "AUTH_OAUTH_CALLBACK_SUCCESS": "Authentification — Callback OAuth réussi",
      "AUTH_OAUTH_CALLBACK_FAILED": "Authentification — Callback OAuth échoué",
      "AUTH_SIGNUP_COUNTRY_MISMATCH": "Authentification — Pays d'inscription incohérent",
      "AUTH_SURVEY_SUBMIT": "Authentification — Envoi du questionnaire",
      "AUTH_IMPERSONATE_START": "Usurpation — Début",
      "AUTH_IMPERSONATE_END": "Usurpation — Fin",
      "AUTH_IMPERSONATE_LANDING": "Usurpation — Page d'arrivée",
      "AUTH_EMERGENCY_MODE_ACTIVATE": "Usurpation — Mode d'urgence",
      "SETUP_INIT": "Configuration — Initialisation",
      "SETUP_COMPLETED": "Configuration — Terminée",
      "AUTH_TEAM_INVITE": "Équipe — Invitation",
      "AUTH_TEAM_INVITE_COMPLETE": "Équipe — Invitation terminée",
      "AUTH_TEAM_SUSPEND": "Équipe — Suspension",
      "AUTH_TEAM_UNSUSPEND": "Équipe — Réactivation",
      "AUTH_TEAM_REASSIGN": "Équipe — Réattribution",
      "MEMBER_SOFT_DELETED": "Membre — Supprimé (soft)",
      "MEMBER_UPDATED": "Membre — Mis à jour",
      "LIMIT_REQUEST_SUBMITTED": "Demande de limite — Soumise",
      "LIMIT_REQUEST_APPROVED": "Demande de limite — Approuvée",
      "LIMIT_REQUEST_REJECTED": "Demande de limite — Rejetée",
      "LIMIT_REQUEST_CANCELLED": "Demande de limite — Annulée",
      "TWO_FA_RESET_BY_ADMIN": "2FA — Réinitialisé par l'admin",
      "CASHBACK_CREDIT": "Facturation — Crédit cashback",
      "REFUND_CREATE": "Facturation — Création de remboursement",
      "INTERNAL_AUTH_REJECTED": "Interne — Authentification rejetée"
    },
    "entityTypeLabels": {
      "User": "Utilisateur",
      "Team": "Équipe",
      "TeamMember": "Membre d'équipe",
      "Merchant": "Marchand",
      "Role": "Rôle",
      "Permission": "Permission",
      "LimitRequest": "Demande de limite",
      "TopupRequest": "Demande de recharge",
      "WithdrawRequest": "Demande de retrait",
      "Chargeback": "Rétrofacturation",
      "Wallet": "Portefeuille",
      "Session": "Session",
      "Orders": "Commandes",
      "Users": "Utilisateurs (personnel admin)",
      "Products": "Produits",
      "Finance": "Finance",
      "Merchants": "Marchands",
      "Vendors": "Fournisseurs",
      "Stores": "Boutiques",
      "SupportTickets": "Tickets de support",
      "Settings": "Paramètres système",
      "FeatureFlags": "Indicateurs de fonctionnalité",
      "KYCDocuments": "Documents KYC",
      "Payouts": "Versements",
      "ImpersonationSessions": "Sessions d'usurpation",
      "ApprovalRequests": "Demandes d'approbation",
      "Addons": "Modules complémentaires",
      "BlueprintsAdmin": "Blueprints (admin)",
      "Bundles": "Lots",
      "Categories": "Catégories",
      "Collections": "Collections",
      "CreditMemos": "Notes de crédit",
      "LegalEntities": "Entités juridiques",
      "PendingApprovals": "Approbations en attente",
      "PrepaymentRequests": "Demandes de prépaiement",
      "Pricing": "Tarification",
      "ProductsSpecial": "Produits spéciaux",
      "RefundTasks": "Tâches de remboursement",
      "RegionErrors": "Erreurs de région",
      "Templates": "Modèles",
      "Techniques": "Techniques",
      "Tickets": "Tickets",
      "TicketMessages": "Messages de ticket",
      "RoleChanges": "Changements de rôle",
      "APIKeyAccess": "Accès clé API",
      "PermissionGrants": "Octrois de permission",
      "EmergencyMode": "Mode d'urgence",
      "AuditExport": "Export d'audit",
      "RetentionConfig": "Configuration de rétention",
      "CustomRoleCRUD": "CRUD rôle personnalisé",
      "FeatureFlagChanges": "Changements d'indicateur",
      "Inventory": "Inventaire",
      "MerchantTransferBlock": "Blocage de transfert marchand"
    },
    "actorRoleLabels": {
      "superadmin": "Super-administrateur",
      "admin": "Administrateur",
      "support_admin": "Admin de support",
      "accountant": "Comptable",
      "system": "Système"
    },
    "severityLabels": {
      "info": "Info",
      "warning": "Avertissement",
      "security": "Sécurité"
    }
  },
  "dualApproval": {
    "reasonTooShort": "Le motif doit contenir au moins 10 caractères.",
    "actionTypes": {
      "refund_large": "Remboursement (élevé)",
      "vendor_wallet_debit_large": "Débit du portefeuille vendeur (élevé)",
      "force_cancel_large": "Annulation forcée (élevé)",
      "bulk_suspend_merchants": "Suspension en masse des marchands",
      "bulk_delete": "Suppression en masse",
      "gateway_key_rotation": "Rotation des clés de passerelle",
      "maintenance_mode_toggle": "Mode maintenance",
      "feature_flag_prod_toggle": "Indicateur de fonctionnalité (production)",
      "kek_rotation": "Rotation de la KEK",
      "audit_log_export": "Export du journal d'audit",
      "impersonate_to_superadmin": "Usurper l'identité du Super Admin",
      "credit_grant_large": "Octroi de crédit (élevé)",
      "pricing_tier_change_large": "Changement de palier tarifaire (élevé)",
      "weight_formula_change": "Changement de formule de poids",
      "credit_memo_approve": "Approuver l'avoir"
    },
    "statusLabels": {
      "pending": "En attente",
      "approved": "Approuvé",
      "executed": "Exécuté",
      "rejected": "Rejeté",
      "expired": "Expiré"
    },
    "card": {
      "initiatedBy": "Initié par",
      "reasonLabel": "Motif :",
      "payloadPreview": "Aperçu du payload",
      "approvalsProgress": "{{n}} / {{required}} approbations",
      "singleSaExemption": "Dérogation Single-SA",
      "singleSaExemptionTooltip": "Selon, l'unique Super Admin actif peut s'auto-approuver à titre dérogatoire",
      "threshold": "Seuil {{currency}} {{amount}}",
      "revalidating": "Revalidation…",
      "revalidateDiff": "Revalider l'écart",
      "revalidateError": "Erreur de revalidation",
      "revalDiffTitle": "Écart de revalidation — demandé vs état actuel",
      "close": "Fermer",
      "diffHighlightTitle": "Mettre en évidence les changements depuis l'initiation",
      "noEffectiveState": "Aucune donnée d'état effectif pour l'instant — cliquez sur Revalider pour récupérer.",
      "selfApproveNotice": "Vous avez initié cette demande — vous ne pouvez pas approuver votre propre demande.",
      "alreadyVoted": "Vous avez déjà voté sur cette demande.",
      "approveCommentLabel": "Commentaire d'approbation (minimum 10 caractères)",
      "approveCommentPlaceholder": "Motif d'approbation (≥10 caractères)",
      "approving": "Approbation…",
      "approve": "Approuver",
      "reject": "Rejeter",
      "rejectReasonLabel": "Motif de rejet (minimum 10 caractères)",
      "rejectReasonPlaceholder": "Motif du rejet de cette demande (≥10 caractères)",
      "rejecting": "Rejet…",
      "confirmReject": "Confirmer le rejet"
    },
    "emergencyBar": {
      "title": "Mode d'urgence actif",
      "scopeLabel": "Portée :",
      "autoExpires": "Expiration automatique dans {{countdown}}",
      "aborting": "Interruption…",
      "abort": "Interrompre",
      "scope": {
        "production": "Production (commandes + paiements)",
        "security": "Sécurité (sessions + KEK + IP)",
        "maintenance": "Maintenance (cron + workers)"
      }
    }
  },
  "security": {
    "severityLabels": {
      "low": "Faible",
      "medium": "Moyen",
      "high": "Élevé",
      "critical": "Critique"
    },
    "statusLabels": {
      "open": "Nouveau",
      "dismissed": "Ignoré",
      "resolved": "Résolu"
    },
    "cancel": "Annuler",
    "anomaly": {
      "title": "Alertes d'anomalie",
      "totalAria": "Nombre total d'événements : {{total}}",
      "eventCount_one": "{{count}} événement",
      "eventCount_other": "{{count}} événements",
      "severityFilter": "Sévérité",
      "statusFilter": "Statut",
      "all": "Tous",
      "refresh": "Actualiser",
      "loadError": "Impossible de charger la liste des alertes.",
      "dismissError": "Impossible d'ignorer l'événement.",
      "loading": "Chargement...",
      "empty": "Aucune alerte.",
      "dismiss": "Ignorer",
      "prev": "Précédent",
      "next": "Suivant",
      "pageInfo": "Page {{page}} / {{totalPages}} — {{total}} événements",
      "columns": {
        "time": "Horodatage",
        "rule": "Règle",
        "severity": "Sévérité",
        "actor": "Acteur",
        "sourceIp": "IP source",
        "status": "Statut",
        "actions": "Actions"
      },
      "dismissDialog": {
        "title": "Ignorer l'alerte",
        "bodyBefore": "Saisissez une raison pour ignorer l'événement ",
        "bodyAfter": ". Cette action sera enregistrée dans le journal d'audit.",
        "reasonLabel": "Motif (minimum 10 caractères)",
        "saving": "Enregistrement...",
        "confirm": "Confirmer l'ignorance"
      }
    },
    "emergency": {
      "title": "Mode d'urgence",
      "subtitle": "Réservé au Super Admin. Nécessite un code 2FA. Expiration automatique après 2 heures.",
      "activeBadge": "ACTIF — {{scope}}",
      "inactiveBadge": "Non actif",
      "activatedBy": "Activé par",
      "startedAt": "Démarré",
      "autoExpiresAt": "Expiration automatique",
      "remaining": "Restant",
      "allowedActions": "Actions autorisées :",
      "abortNow": "Interrompre maintenant",
      "normalState": "Le système fonctionne normalement — aucun Mode d'urgence n'est actif.",
      "activateBtn": "Activer le Mode d'urgence",
      "superAdminOnly": "Seul le Super Admin peut activer.",
      "expired": "Expiré",
      "activateError": "Impossible d'activer le Mode d'urgence.",
      "abortError": "Impossible d'interrompre le Mode d'urgence.",
      "activateTitle": "Activer le Mode d'urgence",
      "activateBody": "Cette action modifiera la configuration de sécurité de tout le système. Nécessite un code 2FA. Expiration automatique après 2 heures. Chaque opération est enregistrée dans le journal d'audit.",
      "scopeField": "Portée",
      "totpLabel": "Code 2FA (6 chiffres)",
      "reasonLabel20": "Motif (≥ 20 caractères)",
      "activating": "Activation...",
      "confirmActivate": "Confirmer l'activation",
      "abortTitle": "Interrompre le Mode d'urgence",
      "abortBody": "Cette opération le désactivera immédiatement. Le journal d'audit enregistrera le motif.",
      "reasonLabel10": "Motif (≥ 10 caractères)",
      "aborting": "Interruption...",
      "confirmAbort": "Confirmer l'interruption",
      "scopeLabels": {
        "production": "Production — bloquer les écritures de données non critiques",
        "security": "Sécurité — blocage IP en masse + révocation forcée des sessions",
        "maintenance": "Maintenance — bloquer les écritures marchand/vendeur"
      }
    }
  },
  "emailTemplates": {
    "testSend": {
      "ariaLabel": "Envoyer un test du modèle d'e-mail",
      "title": "Envoyer un test du modèle",
      "bodyBefore": "Rendre ",
      "bodyAfter": " avec une charge utile d'exemple et l'envoyer à une adresse QA.",
      "langLabel": "Langue",
      "toEmailLabel": "E-mail du destinataire",
      "payloadLabel": "Charge utile d'exemple (JSON)",
      "sending": "Envoi…",
      "sendTest": "Envoyer le test",
      "cancel": "Annuler",
      "errPayloadObject": "La charge utile d'exemple doit être un objet JSON.",
      "errPayloadJson": "JSON invalide — vérifiez la syntaxe.",
      "errEmailRequired": "Veuillez saisir un e-mail de destinataire.",
      "errMissingVars": "Variables requises manquantes : {{vars}}",
      "toastSuccessTitle": "E-mail de test envoyé",
      "toastSuccessDesc": "À {{email}} • message_id {{messageId}}…",
      "toastFailTitle": "Échec de l'envoi de l'e-mail de test",
      "toastUnknownError": "Erreur inconnue. Veuillez réessayer."
    }
  },
  "upload": {
    "networkError": "Impossible de se connecter au serveur.",
    "failed": "Échec du téléversement du fichier."
  }
}
